import { render, staticRenderFns } from "./Ethereum.vue?vue&type=template&id=3f18e368"
import script from "./Ethereum.vue?vue&type=script&lang=ts"
export * from "./Ethereum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports